export enum ActionTypes {
  ClearState = 'ActionClearState',
  ClearError = 'ActionClearError',
  continueExistingApplicationWithConsumerAlert = 'continueExistingApplicationWithConsumerAlert',
}
